export default "__VITE_ASSET__CSUbICKs__"